export default __webpack_public_path__ + "static/media/gill_logo.c7ea82d3.jpg";